// assets/cart-gifts.js
(function () {
  if (typeof document === 'undefined') return;

  var STORAGE_KEY = 'cart_gifts_status_v10';

  var initialized = false;

  var drawerRoot = null;
  var gifts = null;
  var giftStatus = {};
  var lastTotalCents = 0;
  var lastCart = null; // snapshot atual do cart.js

  var root = null;    // <section data-cart-gifts-root>
  var modal = null;   // [data-cart-gifts-modal]
  var totalEl = null; // [data-cart-total]

  var totalObserver = null;
  var renderScheduled = false;

  // ====== NOVO: controle do "não marcou nada" ======
  var hasPendingLastRender = false; // se no último render existia pending.length>0
  var noActionSent = false;         // trava pra não enviar repetido

  function log() {
    // descomente pra silenciar logs:
    return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[CART GIFTS]');
    console.log.apply(console, args);
  }

  // ========== ORIGIN-TRACKING (helpers) ==========

  function originMarkDeclined() {
    try {
      if (window.IALLY_ORIGIN && typeof window.IALLY_ORIGIN.markGiftCartDeclined === 'function') {
        window.IALLY_ORIGIN.markGiftCartDeclined();
        log('origin-tracking: marked brinde_carrinho = declined');
      }
    } catch (e) {}
  }

  function originMarkAcceptedPending(variantId) {
    try {
      if (window.IALLY_ORIGIN && typeof window.IALLY_ORIGIN.markGiftCartAcceptedPending === 'function') {
        window.IALLY_ORIGIN.markGiftCartAcceptedPending(String(variantId));
        log('origin-tracking: marked brinde_carrinho = accepted (pending)', { variantId: String(variantId) });
      }
    } catch (e) {}
  }

  // ===== NOVO: offered/no_action =====
  function originMarkOffered() {
    try {
      if (window.IALLY_ORIGIN && typeof window.IALLY_ORIGIN.markGiftCartOffered === 'function') {
        window.IALLY_ORIGIN.markGiftCartOffered();
        log('origin-tracking: marked brinde_carrinho = offered');
      }
    } catch (e) {}
  }

  function originMarkNoAction() {
    try {
      if (window.IALLY_ORIGIN && typeof window.IALLY_ORIGIN.markGiftCartNoAction === 'function') {
        window.IALLY_ORIGIN.markGiftCartNoAction();
        log('origin-tracking: marked brinde_carrinho = no_action');
      }
    } catch (e) {}
  }

  // marca "não marcou nada" somente quando fizer sentido
  function markNoActionIfEligible(reason) {
    try {
      // precisa ter brinde pendente mostrado em algum momento
      if (!hasPendingLastRender) return;

      // não dispara se já foi enviado
      if (noActionSent) return;

      // se ele já decidiu (accepted/declined), não manda
      // (depende do origin-tracking existir, senão apenas evita duplicar)
      var st = null;
      try {
        st = window.IALLY_ORIGIN && typeof window.IALLY_ORIGIN.get === 'function' ? window.IALLY_ORIGIN.get() : null;
      } catch (_) {
        st = null;
      }

      if (st && st.brinde_carrinho) {
        // como você trocou os textos, a checagem aqui é "contém"
        var s = String(st.brinde_carrinho);
        if (s.indexOf('Brinde aprovado') !== -1) return;
        if (s.indexOf('Brinde negado') !== -1) return;
      }

      noActionSent = true;
      originMarkNoAction();
      log('no_action disparado', { reason: reason || 'unknown' });
    } catch (e) {}
  }

  // ========== STORAGE DE STATUS (SESSION STORAGE) ==========

  function getStorage() {
    try {
      return window.sessionStorage || null;
    } catch (e) {
      return null;
    }
  }

  function loadGiftStatus() {
    try {
      var storage = getStorage();
      if (!storage) return {};
      var raw = storage.getItem(STORAGE_KEY);
      if (!raw) return {};
      var parsed = JSON.parse(raw);
      if (typeof parsed !== 'object' || parsed === null) return {};
      return parsed;
    } catch (e) {
      console.warn('[CART GIFTS] erro ao ler sessionStorage', e);
      return {};
    }
  }

  function saveGiftStatus(status) {
    try {
      var storage = getStorage();
      if (!storage) return;
      storage.setItem(STORAGE_KEY, JSON.stringify(status || {}));
    } catch (e) {
      console.warn('[CART GIFTS] erro ao salvar sessionStorage', e);
    }
  }

  // ========== HELPERS DE VALOR / CART ==========

  function parseMoneyStringToCents(str) {
    if (!str) return 0;
    var s = String(str)
      .replace(/[^\d,.-]/g, '')
      .replace(/\./g, '')
      .replace(',', '.');

    var num = parseFloat(s);
    if (isNaN(num)) return 0;
    return Math.round(num * 100);
  }

  function getGiftKey(g) {
    var id = g.id || '';
    var productId = g.productId || g.product_id || '';
    var threshold = g.threshold || g.threshold_reais || '';
    return String(id || productId) + ':' + String(threshold);
  }

  function getCurrentTotalCents() {
    // Tenta obter o elemento mais atualizado dentro do drawer
    if (drawerRoot) {
      totalEl = drawerRoot.querySelector('[data-cart-total]');
    }

    if (!totalEl) return 0;

    // Se tiver o valor raw (cents) no dataset, usa ele (mais seguro)
    if (totalEl.dataset.cartTotalRaw) {
      var raw = parseInt(totalEl.dataset.cartTotalRaw, 10);
      if (!isNaN(raw)) return raw;
    }

    return parseMoneyStringToCents(totalEl.textContent);
  }

  function getUnlockedGifts(totalCents) {
    if (!Array.isArray(gifts)) return [];
    return gifts.filter(function (g) {
      return totalCents >= g.thresholdCents;
    });
  }

  function variantAlreadyInCart(variantId) {
    if (!variantId) return false;
    if (!lastCart || !Array.isArray(lastCart.items)) return false;
    var vid = String(variantId);
    return lastCart.items.some(function (it) {
      return String(it.variant_id || it.variantId || it.id || '') === vid;
    });
  }

  function getPendingUnlockedGifts(totalCents) {
    var unlocked = getUnlockedGifts(totalCents);

    // Mapa de variants E PRODUTOS no carrinho atual
    var variantIdsInCart = [];
    var productIdsInCart = [];

    if (lastCart && Array.isArray(lastCart.items)) {
      variantIdsInCart = lastCart.items.map(function (it) {
        return String(it.variant_id || it.variantId || it.id || '');
      });
      productIdsInCart = lastCart.items.map(function (it) {
        return String(it.product_id || it.productId || '');
      });
    }

    // Tenta atualizar lastCart se ele estiver vazio ou desatualizado
    if (!variantIdsInCart.length) {
      try {
        var cartDrawerItems = document.querySelectorAll('.cart-drawer__item');
        if (cartDrawerItems.length > 0) {
          variantIdsInCart = Array.from(cartDrawerItems).map(function(item) {
            return String(item.dataset.variantId || '');
          }).filter(Boolean);

          // Tenta pegar product id do dataset se existir (pode precisar ajuste no liquid)
          productIdsInCart = Array.from(cartDrawerItems).map(function(item) {
             return String(item.dataset.productId || '');
          }).filter(Boolean);
        }
      } catch(e) {}
    }

    return unlocked.filter(function (g) {
      var status = giftStatus[g.key];

      // Só "declined" bloqueia o brinde.
      if (status === 'declined') return false;

      // Regra 1: verifica variant ID exato
      if (g.variantId && variantIdsInCart.length) {
        if (variantIdsInCart.indexOf(String(g.variantId)) !== -1) {
          return false;
        }
      }

      // Regra 2: verifica PRODUCT ID (para cobrir trocas de variação)
      // Isso evita que o brinde reapareça se o usuário trocar a cor/tamanho
      if (g.productId && productIdsInCart.length) {
         if (productIdsInCart.indexOf(String(g.productId)) !== -1) {
           return false;
         }
      }

      return true;
    });
  }

  // ========== MODAL (opcional) ==========

  function openModal() {
    if (!modal) refreshRefs();
    if (!modal) return;
    modal.hidden = false;
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
  }

  // ⚠️ Aceitos NÃO vão mais para o sessionStorage
  function markGiftAsAccepted(gift) {
    if (!gift || !gift.key) return;

    // Se por acaso existir lixo antigo "accepted", limpamos
    if (giftStatus[gift.key] && giftStatus[gift.key] !== 'declined') {
      delete giftStatus[gift.key];
      saveGiftStatus(giftStatus);
    }

    log('brinde marcado como accepted (não persistido):', gift.key);
  }

  function markGiftAsDeclined(gift) {
    if (!gift || !gift.key) return;
    giftStatus[gift.key] = 'declined';
    saveGiftStatus(giftStatus);
    log('brinde marcado como declined:', gift.key);
  }

  function markAllPendingAsDeclined(totalCents) {
    var pending = getPendingUnlockedGifts(totalCents);
    pending.forEach(function (g) {
      markGiftAsDeclined(g);
    });
    render(getCurrentTotalCents());
  }

  // ========== AÇÃO: RESGATAR BRINDE (COM LOADING) ==========

  function setButtonLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.disabled = true;
      btn.dataset.loading = 'true';
      var spinner = btn.querySelector('.cart-gifts__btn-spinner');
      if (spinner) spinner.hidden = false;
    } else {
      btn.dataset.loading = 'false';
      var spinner2 = btn.querySelector('.cart-gifts__btn-spinner');
      if (spinner2) spinner2.hidden = true;
    }
  }

  function handleAcceptGift(gift, btn) {
    if (!gift || !gift.variantId) {
      console.warn('[CART GIFTS] brinde sem variantId, não é possível adicionar ao carrinho');
      return;
    }

    log('adicionando brinde ao carrinho:', gift);
    setButtonLoading(btn, true);

    // ✅ marca no origin-tracking ANTES do add (pra garantir property no line item)
    originMarkAcceptedPending(gift.variantId);

    // se aceitou, nunca é "não marcou nada"
    noActionSent = true;

    // Se o brinde já está no carrinho, não tenta adicionar de novo
    if (variantAlreadyInCart(gift.variantId)) {
      log('brinde já estava no carrinho, apenas marcando como accepted:', gift.key);
      markGiftAsAccepted(gift);

      var totalBase =
        lastCart && typeof lastCart.total_price === 'number'
          ? lastCart.total_price
          : getCurrentTotalCents();

      render(totalBase);

      document.dispatchEvent(
        new CustomEvent('cart:gifts:accepted', {
          detail: { giftKey: gift.key, cart: lastCart || null }
        })
      );
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: { cart: lastCart || null }
        })
      );

      setButtonLoading(btn, false);
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: gift.variantId,
        quantity: 1
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Erro ao adicionar brinde ao carrinho');
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (res) {
        if (!res || !res.ok) return null;
        return res.json();
      })
      .then(function (cart) {
        if (cart && typeof cart === 'object') lastCart = cart;

        markGiftAsAccepted(gift);

        var totalFromCart =
          cart && typeof cart.total_price === 'number'
            ? cart.total_price
            : getCurrentTotalCents();

        render(totalFromCart);

        document.dispatchEvent(
          new CustomEvent('cart:gifts:accepted', {
            detail: { giftKey: gift.key, cart: cart || null }
          })
        );
        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: { cart: cart || null }
          })
        );
      })
      .catch(function (err) {
        console.error('[CART GIFTS] erro ao adicionar brinde', err);
        setButtonLoading(btn, false);
        btn.disabled = false;
      });
  }

  // ========== RENDER ==========

  function render(totalCents) {
    if (!root || !Array.isArray(gifts)) return;

    if (totalCents === 0 && lastTotalCents > 0) {
      log('total 0 detectado, usando lastTotalCents:', lastTotalCents);
      totalCents = lastTotalCents;
    }

    lastTotalCents = totalCents;

    var unlocked = getUnlockedGifts(totalCents);
    var pending = getPendingUnlockedGifts(totalCents);

    // ===== NOVO: se existe pending, marca "oferecido" (arma o no_action) =====
    hasPendingLastRender = !!(pending && pending.length);
    if (hasPendingLastRender) {
      originMarkOffered();
      // reset da trava quando voltar a ter pending (nova chance de "não marcou nada")
      noActionSent = false;
    }

    log('render()', {
      totalCents: totalCents,
      unlocked: unlocked.map(function (g) { return g.key; }),
      pending: pending.map(function (g) { return g.key; })
    });

    if (totalCents <= 0 || !unlocked.length || !pending.length) {
      root.hidden = true;
      root.innerHTML = '';
      return;
    }

    root.hidden = false;

    var html = '';
    html += '<h3 class="cart-gifts__title">Você desbloqueou um brinde!</h3>';
    html += '<div class="cart-gifts__list">';

    pending.forEach(function (g) {
      html +=
        '<article class="cart-gifts__item" data-cart-gift-key="' + g.key + '">' +
        '  <div class="cart-gifts__item-image">';
      if (g.image) {
        html += '<img src="' + g.image + '" alt="' + (g.title || 'Brinde') + '">';
      } else {
        html += '<span>🎁</span>';
      }
      html +=
        '  </div>' +
        '  <div class="cart-gifts__item-body">' +
        '    <div class="cart-gifts__item-label">Brinde especial</div>' +
        '    <div class="cart-gifts__item-title">' +
        (g.title || 'Brinde') +
        '</div>' +
        '    <div class="cart-gifts__item-threshold">Desbloqueado em compras a partir de R$ ' +
        g.thresholdReais.toFixed(2).replace('.', ',') +
        '</div>' +
        '    <div class="cart-gifts__item-actions">' +
        '      <button type="button" class="cart-gifts__btn cart-gifts__btn--primary" data-cart-gift-accept>' +
        '        <span class="cart-gifts__btn-label">Resgatar brinde</span>' +
        '        <span class="cart-gifts__btn-spinner" hidden></span>' +
        '      </button>' +
        '      <button type="button" class="cart-gifts__btn cart-gifts__btn--secondary" data-cart-gift-decline>Agora não</button>' +
        '    </div>' +
        '  </div>' +
        '</article>';
    });

    html += '</div>';
    root.innerHTML = html;
  }

  function scheduleRender() {
    if (renderScheduled) return;
    renderScheduled = true;
    requestAnimationFrame(function () {
      renderScheduled = false;
      render(getCurrentTotalCents());
    });
  }

  // ========== REFRESH DE REFERÊNCIAS APÓS RELOAD DO DRAWER ==========

  function refreshRefs() {
    // Atualiza a referência do drawerRoot pois ele pode ter sido substituído
    drawerRoot = document.getElementById('cart-drawer-root');
    if (!drawerRoot) return;

    root = drawerRoot.querySelector('[data-cart-gifts-root]');
    modal = drawerRoot.querySelector('[data-cart-gifts-modal]');
    totalEl = drawerRoot.querySelector('[data-cart-total]');

    if (!root || !totalEl) {
      log('refreshRefs: sem root ou totalEl', { root: !!root, totalEl: !!totalEl });
      return;
    }

    if (totalObserver) totalObserver.disconnect();

    totalObserver = new MutationObserver(function () {
      scheduleRender();
    });

    totalObserver.observe(totalEl, {
      childList: true,
      characterData: true,
      subtree: true
    });

    render(getCurrentTotalCents());
  }

  // ========== EVENTOS DELEGAÇÃO NO DRAWER ==========

  function bindDelegatedEvents() {
    if (!drawerRoot) return;
    if (drawerRoot.__cartGiftsBound) return;
    drawerRoot.__cartGiftsBound = true;

    drawerRoot.addEventListener('click', function (event) {
      var target = event.target;

      // Resgatar brinde
      var acceptBtn = target.closest && target.closest('[data-cart-gift-accept]');
      if (acceptBtn) {
        if (!Array.isArray(gifts)) return;
        var itemEl = acceptBtn.closest('[data-cart-gift-key]');
        if (!itemEl) return;
        var key = itemEl.getAttribute('data-cart-gift-key');
        var gift = gifts.find(function (g) { return g.key === key; });
        if (!gift) return;
        handleAcceptGift(gift, acceptBtn);
        return;
      }

      // "Agora não" individual
      var declineBtn = target.closest && target.closest('[data-cart-gift-decline]');
      if (declineBtn) {
        if (!Array.isArray(gifts)) return;
        var itemEl2 = declineBtn.closest('[data-cart-gift-key]');
        if (!itemEl2) return;
        var key2 = itemEl2.getAttribute('data-cart-gift-key');
        var gift2 = gifts.find(function (g) { return g.key === key2; });
        if (!gift2) return;

        markGiftAsDeclined(gift2);

        // ✅ marcou decisão -> não é no_action
        noActionSent = true;

        // ✅ marca no origin-tracking que ele NEGOU o brinde
        originMarkDeclined();

        render(getCurrentTotalCents());
        return;
      }

      // Modal: clique no backdrop (fechou sem decidir)
      var backdrop = target.closest && target.closest('[data-cart-gifts-modal-backdrop]');
      if (backdrop) {
        closeModal();
        // ✅ fechou o modal sem decidir
        markNoActionIfEligible('modal_backdrop');
        return;
      }

      // Modal: "Ver brindes"
      var goToGifts = target.closest && target.closest('[data-cart-gifts-go-to-gifts]');
      if (goToGifts) {
        closeModal();
        var currentRoot = drawerRoot.querySelector('[data-cart-gifts-root]');
        if (currentRoot && typeof currentRoot.scrollIntoView === 'function') {
          currentRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        return;
      }

      // Modal: "Continuar sem brinde"
      var continueBtn = target.closest && target.closest('[data-cart-gifts-continue]');
      if (continueBtn) {
        var total = getCurrentTotalCents();
        markAllPendingAsDeclined(total);

        // ✅ marcou decisão -> não é no_action
        noActionSent = true;

        // ✅ marca no origin-tracking que ele NEGOU (via modal)
        originMarkDeclined();

        closeModal();
        
        // FORÇA O CHECKOUT
        // Como o botão original é type="submit", podemos disparar o submit do form
        var form = drawerRoot.querySelector('.cart-drawer__actions form');
        if (form) {
          // Injeta input hidden para forçar checkout
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'checkout';
          input.value = 'true';
          form.appendChild(input);

          form.submit();
        } else {
           window.location.href = '/checkout';
        }
        return;
      }
    });

  }

  // ===== NOVO: interceptor de checkout global (capture phase) =====
  function bindSubmitInterceptor() {
    if (window.__cartGiftsSubmitBound) return;
    window.__cartGiftsSubmitBound = true;

    // 1. Intercepta CLICK no botão de checkout (mais forte que submit)
    document.addEventListener('click', function (event) {
      var target = event.target;
      // Procura botão de checkout dentro do drawer actions
      var btn = target.closest && (
        target.closest('button[name="checkout"]') ||
        target.closest('.cart-drawer__actions button[type="submit"]')
      );

      if (!btn) return;
      
      // Garante que é do drawer
      if (!btn.closest('.cart-drawer__actions')) return;

      var total = getCurrentTotalCents();
      var pending = getPendingUnlockedGifts(total);

      // Fallback: se pending vazio, mas existe UI de brindes visível
      if (pending.length === 0 && root && !root.hidden && root.innerHTML.trim().length > 0) {
        // Tenta recalcular forçado
        pending = getPendingUnlockedGifts(total);
        if (pending.length === 0) {
           // Se ainda zero, verifica se tem botões de "Resgatar" na tela
           if (root.querySelector('[data-cart-gift-accept]')) {
             // Força um "pending" fake só pra abrir o modal, se não tiver sido recusado
             // (mas idealmente getPendingUnlockedGifts já deveria retornar)
             log('fallback: pending=0 mas tem UI de brinde visível');
           }
        }
      }

      log('intercept click checkout', { total: total, pending: pending });

      if (pending.length > 0 && total > 0) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        openModal();
      }
    }, true);

    // 2. Intercepta SUBMIT (caso o click falhe ou seja disparado via JS)
    document.addEventListener('submit', function (event) {
      var form = event.target;
      // Verifica se é o form do drawer
      if (!form || !form.closest || !form.closest('.cart-drawer__actions')) return;

      var total = getCurrentTotalCents();
      var pending = getPendingUnlockedGifts(total);

      log('intercept submit (global capture)', { total: total, pending: pending });

      if (pending.length > 0 && total > 0) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        openModal();
      }
    }, true);
  }

  // ===== NOVO: listeners globais para captar abandono sem clicar =====
  function bindNoActionListeners() {
    if (window.__cartGiftsNoActionBound) return;
    window.__cartGiftsNoActionBound = true;

    // Se sair da página / trocar de rota / fechar aba
    window.addEventListener('pagehide', function () {
      markNoActionIfEligible('pagehide');
    }, { capture: true });

    // Se a aba ficar oculta
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        markNoActionIfEligible('visibilitychange_hidden');
      }
    }, { capture: true });

    // Click fora do drawer (tentativa de fechar pelo overlay do drawer, se existir)
    document.addEventListener('click', function (ev) {
      try {
        if (!hasPendingLastRender) return;
        if (!drawerRoot) return;

        // Se o click foi fora do drawerRoot, pode ser fechamento por overlay
        var t = ev.target;
        if (t && drawerRoot && !drawerRoot.contains(t)) {
          // só tenta se o drawer parece "ativo" (fallback leve)
          // (não depende de classe, mas evita falso positivo quando drawer nem está aberto)
          var anyGiftUI = root && !root.hidden && root.innerHTML && root.innerHTML.length > 10;
          if (anyGiftUI) markNoActionIfEligible('click_outside_drawer');
        }
      } catch (e) {}
    }, { capture: true });
  }

  // ========== HOOK NO CART_DRAWER PARA REAPONTAR DEPOIS DO RELOAD ==========

  function hookCartDrawerAPI() {
    var tries = 0;

    function tryHook() {
      tries++;
      var api = window.CART_DRAWER;
      if (api && !api.__giftsPatched) {
        api.__giftsPatched = true;

        var origReload = api.reload;
        if (typeof origReload === 'function') {
          api.reload = async function () {
            var r = await origReload.apply(api, arguments);
            refreshRefs();
            return r;
          };
        }

        var origUpdate = api.updateFromSectionsResponse;
        if (typeof origUpdate === 'function') {
          api.updateFromSectionsResponse = function () {
            origUpdate.apply(api, arguments);
            refreshRefs();
          };
        }

        refreshRefs();
        return;
      }

      if (tries < 50) setTimeout(tryHook, 100);
    }

    tryHook();
  }

  // ========== INIT ==========

  function initCartGifts() {
    if (initialized) return;
    initialized = true;

    drawerRoot = document.getElementById('cart-drawer-root');
    if (!drawerRoot) {
      log('sem #cart-drawer-root, saindo');
      return;
    }

    var dataEl = document.getElementById('BrindesJson');
    if (!dataEl) {
      log('sem #BrindesJson, saindo');
      return;
    }

    var giftsRaw = [];
    try {
      var jsonText = dataEl.textContent.trim() || '{}';
      var parsed = JSON.parse(jsonText);
      giftsRaw = (parsed && (parsed.brindes || parsed.gifts)) || [];
      log('JSON bruto de brindes:', giftsRaw);
    } catch (e) {
      console.error('[CART GIFTS] erro ao parsear BrindesJson', e);
      return;
    }

    if (!Array.isArray(giftsRaw) || !giftsRaw.length) {
      log('nenhum brinde encontrado no JSON');
      gifts = [];
      return;
    }

    gifts = giftsRaw
      .map(function (g) {
        var thresholdReais = Number(g.threshold || g.threshold_reais || 0);
        if (!thresholdReais || isNaN(thresholdReais)) return null;

        return {
          id: g.id || null,
          key: getGiftKey(g),
          productId: g.productId || g.product_id || null,
          variantId: g.variantId || g.variant_id || null,
          title: g.title || 'Brinde especial',
          image: g.image || null,
          thresholdReais: thresholdReais,
          thresholdCents: Math.round(thresholdReais * 100)
        };
      })
      .filter(Boolean);

    if (!gifts.length) {
      log('nenhum brinde válido após normalização');
      return;
    }

    giftStatus = loadGiftStatus();

    // 🧹 MIGRAÇÃO: limpa qualquer coisa que não seja "declined"
    var changed = false;
    Object.keys(giftStatus).forEach(function (key) {
      if (giftStatus[key] !== 'declined') {
        delete giftStatus[key];
        changed = true;
      }
    });
    // Se o user tinha algo pendente/oferecido, agora limpa pra oferecer de novo se precisar
    if (changed) saveGiftStatus(giftStatus);

    log('inicializado com gifts:', gifts);
    log('status inicial de brindes (sessionStorage):', giftStatus);

    bindDelegatedEvents();
    bindSubmitInterceptor();
    bindNoActionListeners();
    refreshRefs();
    hookCartDrawerAPI();

    // Snapshot inicial do carrinho
    try {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res || !res.ok) return null;
          return res.json();
        })
        .then(function (cart) {
          if (cart && typeof cart === 'object') {
            lastCart = cart;
            if (typeof cart.total_price === 'number') {
              window.CART_GIFTS.refresh(cart.total_price);
            } else {
              window.CART_GIFTS.refresh();
            }
          } else {
            window.CART_GIFTS.refresh();
          }
        })
        .catch(function (e) {
          console.warn('[CART GIFTS] erro ao obter cart inicial', e);
        });
    } catch (e) {
      console.warn('[CART GIFTS] exceção ao iniciar snapshot do carrinho', e);
    }
  }

  // ========== API GLOBAL PARA OUTROS SCRIPTS ==========

  window.CART_GIFTS = {
    refresh: function (totalCents) {
      try {
        if (!drawerRoot) drawerRoot = document.getElementById('cart-drawer-root');
        if (!drawerRoot) return;

        refreshRefs();

        if (typeof totalCents === 'number') {
          render(totalCents);
        } else {
          scheduleRender();
        }
      } catch (e) {
        console.warn('[CART GIFTS] erro ao executar CART_GIFTS.refresh()', e);
      }
    },
    
    // Método para outros scripts saberem se devem bloquear checkout
    hasPendingGifts: function() {
      try {
        var total = getCurrentTotalCents();
        var pending = getPendingUnlockedGifts(total);
        return pending.length > 0 && total > 0;
      } catch (e) {
        return false;
      }
    }
  };

  // Reage a eventos globais de atualização do carrinho
  function handleCartEvent(ev) {
    var cart = ev && ev.detail && ev.detail.cart;
    if (cart && typeof cart === 'object') lastCart = cart;

    if (!drawerRoot) drawerRoot = document.getElementById('cart-drawer-root');
    if (!drawerRoot) return;

    if (cart && typeof cart.total_price === 'number') {
      window.CART_GIFTS.refresh(cart.total_price);
    } else {
      window.CART_GIFTS.refresh();
    }
  }

  document.addEventListener('cart:updated', handleCartEvent);
  document.addEventListener('cart-drawer:updated', handleCartEvent);
  document.addEventListener('cart:discount-applied', handleCartEvent);
  document.addEventListener('cart:discount-removed', handleCartEvent);

  // Boot
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartGifts);
  } else {
    initCartGifts();
  }
})();
